<div id="watchlist" class="subBlockContainer entry-loader">
  <div class="subBlockContent">
    <child-header [title]="title"  (closeEvent)="navigateTo('/myCarts')"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="title blade-title-font">
        {{title}}
      </div>
      <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/myCarts']">close</i> -->

      <div id="share-cartBar" class="filter-wrapper">
        <!-- TODO: delete filterCartItems and use shared pipe instead -->
        <div class="flex-item">
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../images/new_ui/filter.png">
            </div>
            <input #searchInput class="searchInput" type="text" [(ngModel)]="searchFilter" placeholder="Filter"
              onfocus="this.placeholder = ''" onblur="this.placeholder = 'Filter'" (ngModelChange)="filterCartItems()">
          </div>
        </div>
      </div>


      <div class="shared-outer-wrapper table-header-allign">
        <table id="cartTable" matSort (matSortChange)="sortData($event)" class="white">
          <thead>
            <tr class="row cart-title-wrapper">
              <th style="padding-left: 15px" [style.width]="currentUserModel?.hideSOH ? '55%' : '45%'" mat-sort-header="description">DESCRIPTION</th>
              <th style="width: 10%;padding-left: 27px;" mat-sort-header="soh" [class.col-hide]="currentUserModel?.hideSOH">SOH</th>
              <th style="width: 15%;" mat-sort-header="price">PRICE</th>
              <th style="width: 15%"></th>
              <!-- <th style="width: 12%"></th> -->
              <th style="width: 15%"></th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="shared-outer-wrapper child-body">
        <table id="cartTable" matSort (matSortChange)="sortData($event)" class="white">
          <thead hidden="true">
            <tr class="row cart-title-wrapper">
              <th style="padding-left: 15px" [style.width]="currentUserModel?.hideSOH ? '55%' : '45%'" mat-sort-header="description">DESCRIPTION</th>
              <th style="width: 10%;padding-left: 27px;" mat-sort-header="soh" [class.col-hide]="currentUserModel?.hideSOH">SOH</th>
              <th style="width: 15%;" mat-sort-header="price">PRICE</th>
              <th style="width: 15%"></th>
              <!-- <th style="width: 12%"></th> -->
              <th style="width: 15%"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="row  product-wrapper product-content-wrapper" *ngFor="let ci of sortedData; let idx = index">
              <div style="padding-left: 15px" [style.width]="currentUserModel?.hideSOH ? '55%' : '45%'">
                <a routerLink='/product/{{ci?.out_stock_code}}' (click)="checkProductDetail(ci?.out_stock_code)">
                  <div class="result_desc">{{ci?.out_description}}</div>
                </a>
              </div>
              <div style="width: 10%;text-align: center;" [class.col-hide]="currentUserModel?.hideSOH">
                <span *ngIf="ci?.out_freight_policy.toString() == 'E'" class="master-tooltip" title="ELECTRONIC">
                  {{ci.out_freight_policy}}
                </span>
                <span *ngIf="ci?.out_freight_policy.toString() == 'L'" class="master-tooltip" title="LABOUR">
                  {{ci.out_freight_policy}}
                </span>
                <span *ngIf="ci?.out_freight_policy != 'L' && ci?.out_freight_policy != 'E'">
                  {{sohLoad(ci).replace('+', '') | number: '.0-0'}}
                </span>
              </div>
              <div style="width: 15%;">
                <span>
                  <ng-container *ngIf="ci?.out_billing_freq=='1'">
                    {{ci?.out_current_price | currency:'AUD':'symbol-narrow':'.2-2'}}/mth
                  </ng-container>
                  <ng-container *ngIf="ci?.out_billing_freq=='Y'">
                    {{ci?.out_current_price | currency:'AUD':'symbol-narrow':'.2-2'}}/year
                  </ng-container>
                  <ng-container *ngIf="ci?.out_billing_freq!=='Y' && ci?.out_billing_freq!=='1'">
                    {{ci?.out_current_price | currency:'AUD':'symbol-narrow':'.2-2'}}
                  </ng-container>
                </span>
              </div>
              <div style="width: 15%;position: relative;">
                <button class="button button-red button-mid" (click)="RemoveWatchItem($event, ci?.out_stock_code)">
                  Delete Item
                </button>
              </div>
              <!-- <div style="width: 12%;position: relative;">
                <button class="button button-red button-mid" (click)="notifyWatchItem($event,ci)">
                  NOTIFICATIONS
                </button>
              </div> -->
              <div style="width: 15%;position: relative;">
                <button class="addBtn{{ci?.out_stock_code}} button button-red button-mid"
                  (click)="addToCart($event,ci)">
                  Add To Cart
                </button>
              </div>
              <div class="cart-result-info col-md-7">
                <div class="produc-secondary-title-wrapper">
                  <span class="light-text">BRAND:&nbsp;</span>
                  <span>{{ci?.out_brand}}</span>
                  <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                  <span class="light-text">SKU:&nbsp;</span>
                  <span>{{ci?.out_stock_code}}</span>
                  <span class="divider-wrapper" *ngIf="ci?.out_rrp_excl_tax">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                  <span class="light-text" *ngIf="ci?.out_rrp_excl_tax">RRP:&nbsp;</span>
                  <span
                    *ngIf="ci?.out_rrp_excl_tax">{{ci?.out_rrp_excl_tax | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                  <div *ngFor="let product of productDetailArray">
                    <span *ngIf="product?.mainProduct?.stockCode==ci?.out_stock_code">
                      <span *ngIf="product?.mainProduct?.promoFinish && product?.mainProduct?.promoFinish !== null">
                        <img class="center" src="../images/new_ui/promotion.png">
                        <span class="bold-text center">PROMOTION:</span> <span class="light-text center">ENDS
                          ON {{product?.mainProduct?.promoFinish}}</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <loading-screen *ngIf="!loadContent" [showBlurTable]="false" backDropWidth="983"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>

<!-- <div #entry>
  <router-outlet></router-outlet>
</div> -->
<router-outlet></router-outlet>
